import React from 'react';
import {
    Formik,
    Form,
    Field,
    ErrorMessage
} from 'formik';

import { observer } from 'mobx-react-lite';
import { UserLoginFormValues } from '../../../app/models/user';
import { useStore } from '../../../app/stores/store';
import { Box, Button, FormControl, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { signInSchema } from '../../../app/common/formValidations/validationSchemes';
import LoginIcon from '@mui/icons-material/Login';
import ResetPasswordEmailForm from './ResetPasswordEmailForm';

const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        bgcolor: '#DAE5F1',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    })
};

export default observer(function Login() {
    const { userStore, modalStore } = useStore();

    const { login } = userStore;

    const matches = useMediaQuery('(min-width:900px)');

    const initialValues: UserLoginFormValues = { email: '', password: '' };

    return (
        <Box sx={style(matches)}>
            <Typography variant='h4' textAlign='center'>Hi Again</Typography>
            <Formik
                initialValues={initialValues}
                validationSchema={signInSchema}
                onSubmit={(values, { setSubmitting }) => {
                    const loginValues: UserLoginFormValues = {
                        email: values.email,
                        password: values.password
                    };
                    login(loginValues);
                    setSubmitting(false);
                }}
            >
                {({ values,
                    handleChange,
                    handleBlur,
                    isSubmitting, }) => {
                    return (
                        <Form autoComplete="off">
                            <Stack direction='column' spacing={2} m={2} alignItems='center'>
                                <FormControl sx={{ width: 300 }}>
                                    <Field
                                        type="text"
                                        component={TextField}
                                        id="email"
                                        name="email"
                                        placeholder="Email"
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                        variant="outlined"
                                    />
                                    <ErrorMessage name="email" component="div" />
                                </FormControl>
                                <FormControl sx={{ width: 300 }}>
                                    <Field
                                        type="password"
                                        component={TextField}
                                        id="password"
                                        name="password"
                                        placeholder="Password"
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.password}
                                        variant="outlined" />
                                    <ErrorMessage name="password" component="div"/>
                                </FormControl>
                                <Stack
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                                pt={2}
                            >
                                    <Button size="medium" type='submit' variant="contained" color="primary" endIcon={<LoginIcon />}>Login</Button>
                                    <Button size="medium" type='submit' variant="contained" color="primary" 
                                    onClick={() => modalStore.openModal(<ResetPasswordEmailForm />)}>Forget Password!</Button>
                                </Stack>
                                </Stack>
                        </Form>
                    );
                }}
            </Formik>
        </Box>
    );
});